app.registerLib('helpers', function (app) {


    //==========================================================xdiv2====
    // main object attributes and methods
    //===================================================================

    var o = {
        funcs: {},
        screenBreakpoints: {
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4
        }
    };

    // Copies references to each function within o.funcs to the specified targetObject.
    // Can be handy if it is desired to make all helper functions more easily accessible.
    // Loading them to window, for example would mean a helper function could be accessed with
    // myFunc(), rather than app.helpers.funcs.myFunc().
    o.loadFuncsTo = function (targetObject) {
        targetObject.h = {};
        Object.keys(o.funcs).forEach(function (funcName) {
            if (typeof targetObject[funcName] !== 'undefined') {
                throw 'Function ' + funcName + ' is already defined on the target object!';
            }
            targetObject.h[funcName] = o.funcs[funcName];
        });
    };

    //==========================================================xdiv2====
    // registering of all helpers
    //===================================================================

    //---------------------------------------------------xdiv3----
    // http
    //------------------------------------------------------------

    o.funcs.baseUrl = function () {
        var pathArray = location.href.split('/');
        var protocol = pathArray[0];
        var host = pathArray[2];
        var url = protocol + '//' + host;
        return url;
    };

    o.funcs.url = function (value) {
        var baseUrl = o.funcs.baseUrl();
        if (arguments.length) {
            var output = baseUrl + '/' + value.replace(/^\/+/g, '');
            return output;
        }
        return baseUrl;
    };

    //---------------------------------------------------xdiv3----
    // date helpers
    //------------------------------------------------------------

    // Converts a SQL formatted string to a native Javascript date object.
    o.funcs.sqlDateToDateObj = function (str) {
        var t = str.split(/[-]/);
        var d = new Date(t[0], t[1] - 1, t[2], 0, 0, 0);
        return d;
    };

    // Converts a native javascript date object to a pretty, human-readable string.
    o.funcs.dateObjToHuman = function (d) {
        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        var day = d.getDate();
        var monthIndex = d.getMonth();
        var year = d.getFullYear();

        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    };

    // Extracts the time from a SQL date string.
    o.funcs.sqlDateTimeToTime = function (str) {
        return str.substring(11, 16);
    };

    //---------------------------------------------------xdiv3----
    // dom helpers
    //------------------------------------------------------------

    // If $parent is null, returns all dom elements matching selector.
    // If $parent is not null, returns all dom elements beneath $parent.
    // $parent should be a jQuery DOM node / collection of nodes.
    o.funcs.resolveScope = function (selector, $parent) {
        if (($parent === undefined) || ($parent === null)) {
            return $(selector);
        } else {
            return $parent.find(selector);
        }
    };

    o.funcs.decodeEntities = function (encodedString) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value;
    };

    o.funcs.getLoadMaskHtml = function () {
        var $elem = $('#load-mask-template');
        var docFragment = o.funcs.getTemplateHtml($elem.get(0));
        var htmlNodes = o.funcs.getTemplateHtml($('#load-mask-template').get(0)).querySelectorAll('.template-inner');
        return htmlNodes[0].innerHTML;
    };

    o.funcs.addLoadMaskTo = function ($elem) {
        var alreadyHasLoadMask = !!$elem.find('.load-mask').length;
        if (alreadyHasLoadMask) return;
        $elem.css({
            position: 'relative'
        });
        var html = o.funcs.getLoadMaskHtml();
        $elem.prepend(html);
        $elem.find('.load-mask').css({
            height: $elem.css('height')
        });
    };

    o.funcs.removeLoadMaskFrom = function ($elem) {
        $elem.find('.load-mask').remove();
    };

    // Reapplies element to the DOM so that it is read as an assertive alert by screen readers
    o.funcs.read = function ($elem) {
        var html = $elem.html();
        $elem.hide().attr('aria-hidden', 'true')
            .show().attr('aria-hidden', 'false')
            .attr('aria-live', 'assertive')
            .attr('role', 'alert')
            .html(html);
    };

    // Appends loading classes, disabled classes, and disabled attributes to supplied elements, and inner elements.
    // If second argument is true, appends a spinner to the button(s) supplied in the first argument.
    o.funcs.loadifyButtons = function ($btns, addLoadIndicatorToButton) {
        addLoadIndicatorToButton = typeof addLoadIndicatorToButton !== 'undefined' ? addLoadIndicatorToButton : false;
        $btns.each(function (k, btn) {
            var $btn = $(btn);
            $btn.addClass('loading-btn').addClass('disabled').attr('disabled', 'disabled');
            var disablable = ['a', 'input', 'button'];
            if ($.inArray($btn.prop('tagName').toLowerCase(), disablable)) {
                $btn.find(disablable.join()).attr('disabled', 'disabled');
            }
        });
        if (addLoadIndicatorToButton) {
            o.funcs.addLoadIndicatorToButton($btns);
        }
    };

    // Removes loading classes, disabled classes, and disabled attributes from supplied elements, and inner elements.
    // If second argument is true, removes spinner markup from the button(s) supplied in the first argument.
    o.funcs.deloadifyButtons = function ($btns, removeLoadIndicatorFromButton) {
        removeLoadIndicatorFromButton = typeof removeLoadIndicatorFromButton !== 'undefined' ? removeLoadIndicatorFromButton : false;
        $btns.each(function (k, btn) {
            var $btn = $(btn);
            $btn.removeClass('loading-btn').removeClass('disabled').removeAttr('disabled');
            var disablable = ['a', 'input', 'button'];
            if ($.inArray($btn.prop('tagName').toLowerCase(), disablable)) {
                $btn.find(disablable.join()).removeAttr('disabled');
            }
        });
        if (removeLoadIndicatorFromButton) {
            o.funcs.removeLoadIndicatorFromButton($btns);
        }
    };

    // Returns spinner HTML. By default, either the white or the black spinner will be hidden with CSS.
    // CSS overrides should be used to hide one and display the other, when desired.
    // Markup for both is included, as in some circumstances, the colour of the spinner needs to change
    // based on screen width.
    o.funcs.getSpinnerHtml = function (useThin) {
        useThin = typeof useThin !== 'undefined' ? !!useThin : false;
        return [
            '<span class="spinner-wrap">',
            '<img aria-hidden="true" class="spinner-white" src="' + o.funcs.url('Resources/app/assets/img/ui/spinner-white' + (useThin ? '' : '-thick') +'.gif') + '" />',
            '<img aria-hidden="true" class="spinner-black" src="' + o.funcs.url('Resources/app/assets/img/ui/spinner-black' + (useThin ? '' : '-thick') +'.gif') + '" />',
            '</span>'
        ].join('');
    };

    // Adds a loading spinner to the inside of the supplied element(s).
    // Designed with .btn elements in mind.
    o.funcs.addLoadIndicatorToButton = function ($target) {
        if ($target && $target.length && $target instanceof jQuery) {
            var $appendTo = $target;
            var $btnInner = $target.find('.btn-inner');
            if ($btnInner.length) $appendTo = $btnInner;
            if (!$appendTo.find('.spinner-wrap').length) {
                $appendTo.append(o.funcs.getSpinnerHtml());
            }
        }
    };

    // Removes any loading spinners from the inside of the supplied element(s).
    // Designed with .btn elements in mind.
    o.funcs.removeLoadIndicatorFromButton = function ($btn) {
        $btn.find('.spinner-wrap').remove();
    };

    //---------------------------------------------------xdiv3----
    // logging helpers
    //------------------------------------------------------------

    // An abstraction around console.log.
    // Gives retrospective control over all calls to logging functions.
    // All console logging code in this application should ideally use this
    // over the native console.log.
    o.funcs.log = function (msg, keys) {

        var cols = {
            kor: '#eeeeee',
            std: '#dddddd',
            load_loading: '#5eafff',
            load_loaded: '#eeefff',
            load_loadDone: '#6688ee',
            kla_reg: '#cc0000',
            kla_ext: '#00cc00',
            imp: ['#772222', '#ffffff'],
        };

        var c = Kor.lib('config');
        var debug = c.get('debug');
        var allowedKeys = c.get('debugKeys');
        var inAllowedKeys = true; // allow by default
        var key;
        if (keys instanceof Array) {
            inAllowedKeys = keys.some(function (v) {
                return allowedKeys.indexOf(v) > -1;
            });
            key = keys[0];
        } else {
            key = keys;
            inAllowedKeys = allowedKeys.indexOf(key) > -1;
        }
        if (debug && inAllowedKeys) {
            var style;
            if (cols[key] instanceof Array) {
                style = 'background: ' + cols[key][0] + '; color: ' + cols[key][1] + ';';
            } else {
                style = 'color: ' + cols[key] + ';';
            }
            console.log('%c ' + msg + ' ', style);
        }
    };

    //---------------------------------------------------xdiv3----
    // math helpers
    //------------------------------------------------------------

    // Returns a whole integer between min and max. (Inclusive).
    o.funcs.rand = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    o.funcs.bytesToMb = function (bytes) {
        return Math.round(bytes / 1024 / 1024);
    };

    o.funcs.generateGUID = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    //---------------------------------------------------xdiv3----
    // object and array helpers
    //------------------------------------------------------------

    // Converts GET string (i.e. foo=bar&baz=borg) to object.
    o.funcs.unparm = function (qstr) {
        if (!qstr) return {};
        var query = {};
        var a = qstr.split('&');
        for (var i = 0; i < a.length; i++) {
            var b = a[i].split('=');
            query[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
        }

        return query;
    };

    // Returns true if str is a string that can be parsed as valid JSON.
    o.funcs.isJsonString = function (str) {
        if (['number', 'object', 'undefined', 'boolean'].indexOf(typeof str) > -1) return false;
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    // Merges all arguments into a single array.
    o.funcs.arrayMerge = function () {
        var args = Array.prototype.slice.call(arguments),
            argl = args.length,
            arg,
            retObj = {},
            k = '',
            argil = 0,
            j = 0,
            i = 0,
            ct = 0,
            toStr = Object.prototype.toString,
            retArr = true;

        for (i = 0; i < argl; i++) {
            if (toStr.call(args[i]) !== '[object Array]') {
                retArr = false;
                break;
            }
        }

        if (retArr) {
            retArr = [];
            for (i = 0; i < argl; i++) {
                retArr = retArr.concat(args[i]);
            }
            return retArr;
        }

        for (i = 0, ct = 0; i < argl; i++) {
            arg = args[i];
            if (toStr.call(arg) === '[object Array]') {
                for (j = 0, argil = arg.length; j < argil; j++) {
                    retObj[ct++] = arg[j];
                }
            } else {
                for (k in arg) {
                    if (arg.hasOwnProperty(k)) {
                        if (parseInt(k, 10) + '' === k) {
                            retObj[ct++] = arg[k];
                        } else {
                            retObj[k] = arg[k];
                        }
                    }
                }
            }
        }

        return retObj;
    };

    // Removes element v from a if present, adds if it is not.
    o.funcs.arrayToggle = function (a, v) {
        var i = a.indexOf(v);
        if (i === -1)
            a.push(v);
        else
            a.splice(i, 1);
    };

    // Returns true if object has prop attribute, and it is not inherited from a prototype.
    // Similar to PHP's isset($obj, 'prop');
    o.funcs.hasOwnProp = function (obj, prop) {
        var proto = obj.__proto__ || obj.constructor.prototype;
        return (prop in obj) &&
            (!(prop in proto) || proto[prop] !== obj[prop]);
    };

    // Converts a variable to a boolean, loosely.
    o.funcs.booleanCast = function (subject) {
        if (subject === 'false') return false;
        if (subject === '0') return false;
        return !!subject; // return boolean version by using double negation
    };

    // Converts an object to an array, loosely.
    o.funcs.arrayCast = function (subject, sep) {
        if (typeof subject == 'object') {
            var o = $.map(subject, function (value, index) {
                return [value];
            });
            return o;
        }
        if (typeof subject == 'string') {
            if (arguments.length == 2) {
                return subject.split(sep);
            }
            return [subject];
        }
        return [subject];
    };

    // Checks to see if subject is an array, and has at least one element.
    o.funcs.isStockedArray = function (subject) {
        return !!(subject instanceof Array && subject.length);
    };

    // Returns true if needle is in array haystack, or false if not.
    o.funcs.inArray = function (needle, haystack) {
        var length = haystack.length;
        for (var i = 0; i < length; i++) {
            if (haystack[i] == needle) return true;
        }
        return false;
    };

    // Returns random element from array, arr.
    o.funcs.randElem = function (arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    };

    // Allows values to be easily extracted from deep array using dot notation.
    // If value is not set, returns d argument.
    // Argument i is the array or object, argument k is the value to find.
    // Example: arrayGet(restaurant, 'meals.vegetarian.curry', 'sandwiches');
    o.funcs.arrayGet = function (i, k, d) {
        if (typeof d === 'undefined') { d = null; }
        if (!k) return i;
        var s = k.split('.');
        var o = i;
        for (var x = 0; x < s.length; x++) {
            if (null !== o && o.hasOwnProperty(s[x])) {
                o = o[s[x]];
            } else {
                return d;
            }
        }
        return o;
    };

    // Sets an value in an array or object deeply, using dot notation.
    // i.e arraySet(animals, 'insects.spiders.hairy', tarantula);
    o.funcs.arraySet = function (i, k, v) {
        if (!k) return;
        var s = k.split('.');
        h = i;
        for (var x = 0; x < s.length - 1; x++) {
            if (h.hasOwnProperty(s[x])) {
                h = h[s[x]];
            } else {
                for (var y = s.length - 1; x <= y; y--) {
                    w = v;
                    v = {};
                    v[s[y]] = w;
                }
                h[s[x]] = v[s[x]];
                return;
            }
        }
        h[s[x]] = v;
    };

    o.funcs.arraySetIfNotSet = function (i, k, v) {
        var got = o.funcs.arrayGet(i, k, null);
        if (!got) {
            o.funcs.arraySet(i, k, v);
        }
    };

    // Flips an arrays key and values.
    // Converts {foo: 'f', bar: 'b'} to {f: 'foo', b: 'bar};
    o.funcs.arrayFlip = function (arr) {
        var flipped = Object.keys(arr)
            .filter(arr.hasOwnProperty.bind(arr))
            .reduce(function (obj, key) {
                obj[arr[key]] = key;
                return obj;
            }, {});
        return flipped;
    }

    o.funcs.shuffle = function (a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
    }

    // Splits an array into chunks of specified size.
    // Example input: array_chunk(['Kevin', 'van', 'Zonneveld'], 2)
    // Example output: [['Kevin', 'van'], ['Zonneveld']]
    // Source: http://locutus.io/php/array_chunk/
    o.funcs.arrayChunk = function (input, size, preserveKeys) {

        // Modulus remainder counter
        var x

        // Property key
        var p = ''

        // An operation index
        var i = 0

        // An operation index
        var c = -1

        // The length of the input
        var l = input.length || 0

        // The chunked output array
        var n = []

        if (size < 1) {
            return null
        }

        if (Object.prototype.toString.call(input) === '[object Array]') {
            if (preserveKeys) {
                while (i < l) {
                    (x = i % size)
                        ? n[c][i] = input[i]
                        : n[++c] = {}; n[c][i] = input[i]
                    i++
                }
            } else {
                while (i < l) {
                    (x = i % size)
                        ? n[c][x] = input[i]
                        : n[++c] = [input[i]]
                    i++
                }
            }
        } else {
            if (preserveKeys) {
                for (p in input) {
                    if (input.hasOwnProperty(p)) {
                        (x = i % size)
                            ? n[c][p] = input[p]
                            : n[++c] = {}; n[c][p] = input[p]
                        i++
                    }
                }
            } else {
                for (p in input) {
                    if (input.hasOwnProperty(p)) {
                        (x = i % size)
                            ? n[c][x] = input[p]
                            : n[++c] = [input[p]]
                        i++
                    }
                }
            }
        }

        return n
    }

    //---------------------------------------------------xdiv3----
    // string helpers
    //------------------------------------------------------------

    // Returns str with an lowercase first letter. i.e. Foo becomes foo.
    o.funcs.lcFirst = function (str) {
        str += '';
        var f = str.charAt(0).toLowerCase();
        return f + str.substr(1);
    };

    // Returns str with an uppercase first letter. i.e. foo becomes Foo.
    o.funcs.ucFirst = function (str) {
        str += '';
        var f = str.charAt(0).toUpperCase();
        return f + str.substr(1);
    };

    // Converts snake cased things i.e. 'only-a-test' to camel cased 'onlyATest'
    o.funcs.camelCase = function (s) {
        s = s.replace(/([^a-zA-Z0-9_\- ])|^[_0-9]+/g, "").trim().toLowerCase();
        s = s.replace(/([ -]+)([a-zA-Z0-9])/g, function (a, b, c) {
            return c.toUpperCase();
        });
        s = s.replace(/([0-9]+)([a-zA-Z])/g, function (a, b, c) {
            return b + c.toUpperCase();
        });
        return s;
    };

    // Converts camel cased things i.e. 'onlyATest' to snake cased 'only-a-test'
    o.funcs.snakeCase = function (s) {
        var o = s.replace(/\.?([A-Z]+)/g, function (x, y) { return "_" + y.toLowerCase() }).replace(/^_/, "");
        if (arguments.length == 2) {
            o = o.replace(/_/g, arguments[1]);
        }
        return o;
    };

    // Formats a number with commas separating every 3 digits.
    // i.e. 1000000 becomes '1,000,000'
    o.funcs.numberWithCommas = function (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Replaces instances of regex with replacementHTML within supplied textNode.
    o.funcs.replaceCharacterPlaceholderWithElement = function (textNode, regex, replacementHtml) {
        regex = typeof regex !== 'undefined' ? regex : /\{0\}/g;
        replacementHtml = typeof replacementHtml !== 'undefined' ? replacementHtml : '<var class="value"></var>';
        var text = textNode.text();
        var replaceWith = text.replace(regex, replacementHtml);
        textNode.replaceWith(replaceWith);
    }

    // Replaces specified attribute of specified DOM element, with replacement according to specified regex and replacement string.
    o.funcs.replaceAttributeOfNode = function ($elem, attrName, regex, replacementText) {
        var currentText = $elem.attr(attrName);
        var replaceWith = currentText.replace(regex, replacementText);
        $elem.attr(attrName, replaceWith);
    }

    //---------------------------------------------------xdiv3----
    // system
    //------------------------------------------------------------

    o.funcs.openBorderlessLink = function (href) {
        window.open(href,
            'open_window',
            'menubar=no, toolbar=no, location=no, directories=no, status=no, scrollbars=no, resizable=no, dependent, width=800, height=620, left=0, top=0')
    },

    // Returns the HTML from a <template> tag.
    // In using this method, instead of just "element.content",
    // we can support ie, which can't natively do this. (Even recent versions of ie).
    o.funcs.getTemplateHtml = function (element) {

        if (element.content) {
            return element.content;
        }

        var elPlate = element,
            qContent,
            docContent;

        qContent = elPlate.childNodes;
        docContent = document.createDocumentFragment();

        while (qContent[0]) {
            docContent.appendChild(qContent[0]);
        }

        elPlate.content = docContent;
        return docContent;

    };

    // Copies to clipboard automatically if possible.
    // If not possible, shows prompt, along with instructions on how to do this manually.
    o.funcs.copyElementText = function ($elem, callback, promptFallback) {
        promptFallback = typeof promptFallback !== 'undefined' ? promptFallback : true;
        var defPromptFallbackMsg = 'You may copy the text below. On most devices, you can do this by pressing CTRL+C, then enter.';
        var promptFallbackMsg = (typeof promptFallback === 'string') ? promptFallback : defPromptFallbackMsg;
        var elem = $elem.get(0);
        elem.select();
        try {
            var successful = document.execCommand('copy');
            if (typeof callback !== 'undefined') {
                callback(successful);
            }
        } catch (err) {
            if (typeof callback !== 'undefined') {
                callback(false);
            }
            if (promptFallback) {
                window.prompt(promptFallbackMsg, text);
            }
        }
    };

    o.funcs.debouncer = function (func, wait, immediate) {
        immediate = typeof immediate !== 'undefined' ? immediate : true;
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    o.funcs.throttler = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function () {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function () {
            var now = Date.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    // Adds feature classes to the body DOM element, based on the results of the feature detection
    // methods written below. Useful for conditional CSS styling and JS behaviour.
    o.funcs.addCssFeatureClasses = function () {
        $('body').addClass(o.funcs.isIe() ? 'isIe' : 'isNotIe');
        $('body').addClass(o.funcs.pointerEventsSupported() ? 'pointerEventsSupported' : 'pointerEventsNotSupported');
        $('body').addClass(o.funcs.touchSupported() ? 'touchSupported' : 'touchNotSupported');
        $('body').addClass(o.funcs.isMobile() ? 'isMobile' : 'notMobile');
        $('body').addClass(o.funcs.isIpad() ? 'isIpad' : 'notIpad');
        o.funcs.addCssFeatureClassesOnResize();
    };

    // As per addCssFeatureClasses, but handles the adding of contextual classes
    // that may change on the window resize event. Note that these are called
    // by addCssFeatureClasses, which intends to add all on page load.
    o.funcs.addCssFeatureClassesOnResize = function () {
        var orientation = o.funcs.getOrientation();
        $('body')
            .removeClass('orientationPortrait')
            .removeClass('orientationLandscape')
            .addClass('orientation' + o.funcs.ucFirst(orientation))
            .removeClass('screenSizeXs').removeClass('screenSizeSm').removeClass('screenSizeMd').removeClass('screenSizeLg')
            .addClass('screenSize' + o.funcs.ucFirst(o.funcs.getScreenSize()));
    };

    o.funcs.getScreenSize = function () {
        if ($('.device-xs').is(':visible')) return o.screenBreakpoints.xs;
        if ($('.device-sm').is(':visible')) return o.screenBreakpoints.sm;
        if ($('.device-md').is(':visible')) return o.screenBreakpoints.md;
        if ($('.device-lg').is(':visible')) return o.screenBreakpoints.lg;
    };

    // Makes an educated guess about if the user agent is a mobile or not.
    o.funcs.isMobile = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    // Makes an educated guess about if the user agent is an iPad or not.
    o.funcs.isIpad = function () {
        return navigator.userAgent.match(/iPad/i) != null;
    };

    // Makes an educated guess about if the user agent is safari
    o.funcs.isSafari = function () {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    };

    // browser / feature detection
    // (yes, when a browser lies about the features that it supports,
    // it does sometimes become prudently beneficial
    // to detect browsers over features!)
    o.funcs.isIe = function () {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    };

    o.funcs.isFirefox = function () {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    };

    // Returns true if we are on a touchscreen device
    o.funcs.touchSupported = function () {
        return ('ontouchstart' in document.documentElement);
    };

    // Returns true if pointer events are supported.
    o.funcs.pointerEventsSupported = function () {
        // return false;
        var allegedly = 'pointerEvents' in document.documentElement.style;
        var ie = this.isIe();
        var isOldIe = (ie && ie < 12);
        return (allegedly && (!isOldIe));
    };

    // Returns true if javascript FileReader is supported,
    // which can be used to show image previews before form submit.
    o.funcs.fileReaderSupported = function () {
        return typeof (FileReader !== 'undefined');
    };

    //Takes a string as the form id and deploys an invisible ReCaptcha.
    o.funcs.protectFormInvisibleCaptcha = function ($form) {
        var form = $form.get(0);
        if (!form) {
            return;
        }
        var capWrapDiv = form.querySelector('.cap-wrap');
        
        return grecaptcha.render(capWrapDiv, {
            sitekey: dataStore.get('config.ReCaptchaApiKey'),
            hl: document.querySelector('html').getAttribute('lang'),
            badge: 'inline',
            'expired-callback': function() {
                app.helpers.funcs.resetRecaptcha();
            },
            'error-callback': function() {
                app.helpers.funcs.resetRecaptcha();
            }
        });
    };

    o.funcs.resetRecaptcha = function () {
        grecaptcha.reset();
    };

    o.funcs.resetSubmitButtonRecaptchaHidden = function ($btns) {
        var iframe = document.querySelector('iframe[src^="https://challenges.cloudflare.com"]');
        var container = iframe.closest('.cap-wrap');
        if (container) {
            var $container = $(container);
            if (!$container.data("observer-set")) {
                new MutationObserver(function () { container.style.opacity == 0 && app.helpers.funcs.deloadifyButtons($btns, true) })
                    .observe(container, { attributes: true, attributeFilter: ["style"] });
                $container.data("observer-set", true);
            }            
        } 
    };

    // Returns 'landscape' when width is greater than height, or otherwise, portrait.
    o.funcs.getOrientation = function () {
        var orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
        return orientation;
    };

    // Accepts a jquery collection of elements ($items), which it then normalises the heights of.
    // This function assumes that all items are siblings.
    // You must supply a list of "items per breakpoint" in order for this to work correctly.
    // i.e. {xs: 1, sm: 2, md: 3, lg: 3}
    o.funcs.equaliseDivHeights = function ($items, itemsPerRowPerBreakpoint) {
        itemsPerRowPerBreakpoint = itemsPerRowPerBreakpoint || {};
        $items.height('');
        var breakpoint = o.funcs.getScreenSize();
        var itemsPerRow = itemsPerRowPerBreakpoint[breakpoint] || false;
        if (itemsPerRow < 2) return;
        var itemSets = [];
        $items.each(function (k, item) {
            var $item = $(item);
            var itemSetKey = Math.max(0, Math.round((k - 1) / itemsPerRow));
            if (!itemSets[itemSetKey]) {
                itemSets[itemSetKey] = {
                    maxHeight: 0,
                    items: []
                };
            }
            itemSets[itemSetKey].items.push($item);
            itemSets[itemSetKey].maxHeight = Math.max(itemSets[itemSetKey].maxHeight, $item.height());
        });
        itemSets.forEach(function (itemSet, k) {
            itemSet.items.forEach(function ($item) {
                $item.height(itemSet.maxHeight);
            });
        });
    };

    o.funcs.equaliseColumnHeightsInRow = function ($row, selector) {
        selector = selector || false;
        if (selector) {
            var $items = $row.find(selector);
        } else {
            var $items = $row.find('> div');
        }
        var maxHeight = 0;
        $items.each(function (k, item) {
            var $item = $(item);
            $item.height('');
            var height = $item.height();
            maxHeight = Math.max(height, maxHeight);
        });
        $items.each(function (k, item) {
            var $item = $(item);
            $item.height(maxHeight);
        });
    };

    o.funcs.validateDocuments = function(documentIds, saveFunction, notifyEvent, toastMessage) {
        if (saveFunction && notifyEvent && documentIds) {
            if (documentIds.length > 0) {
                $.ajax({
                    url: '/umbraco/api/DocumentApi/DocumentsExist',
                    type: 'post',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(documentIds),
                    success: function(response) {
                        var allExist = true;
                        var documents = response.result;
                        for (var i = 0; i < documents.length; i++) {
                            if (!documents[i].exists) {
                                allExist = false;
                                app.mediator.notify(notifyEvent, { documentId: documents[i].id });
                            }
                        }

                        if (allExist) {
                            saveFunction();
                        } else {
                            app.ui.uiPlugins.toast.fire(toastMessage, 'danger');
                        }
                    }
                });
            } else {
                saveFunction();
            }
        }
    };

    o.funcs.replaceTokens = function (template, tokens) {
        return template.replace(/##(.*?)##/g, (_, key) => tokens[key] ?? `##${key}##`);
    };

	return o;
});
